module.exports = __webpack_public_path__ + "img/img2.2660bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img2.png
// module id = 175
// module chunks = 0